import "./education-info.scss";
type EducationPageProps = {};

const EducationPage = (props: EducationPageProps) => {
  return (
    <>
      <div className="education-info page">
        <div className="education-info__header page__header">
          <h1 className="education-info__header__title page__header__title">
            ОБРАЗОВАНИЕ
          </h1>
        </div>
        <div className="education-info__content">
          <div className="education-info__content__item">
            <h1 className="education-info__content__item__header">
              2020 - 2021 г.
            </h1>
            <p className="education-info__content__item__description">
              <strong>Обучаваща организация - </strong>
              ЮЗУ „Неофит Рилски“ гр. Благоевград
            </p>
            <p className="education-info__content__item__description">
              <strong>Специалност - </strong>Предучилищна и начална училищна
              педагогика
            </p>
            <p className="education-info__content__item__description">
              <strong>МГ - </strong>Педагогическо взаимодействие с деца с
              проблемно поведение
            </p>
            <p className="education-info__content__item__description">
              <strong>Професионална квалификация - </strong>
              Магистър-Педагог-Консултант
            </p>
            <p className="education-info__content__item__description">
              <strong>Образователно-квалификационна степен - </strong>Магистър
            </p>
          </div>
          <div className="education-info__content__item">
            <h1 className="education-info__content__item__header">
              2016-2020г.
            </h1>
            <p className="education-info__content__item__description">
              <strong>Специалност - </strong>Предучилищна и начална училищна
              педагогика
            </p>
            <p className="education-info__content__item__description">
              <strong>Професионална квалификация - </strong>
              Педагог,Детски учител и начален учител
            </p>
            <p className="education-info__content__item__description">
              <strong>Образователно-квалификационна степен - </strong>Бакалавър
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default EducationPage;
